import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { colors } from "../../theme/colors";

export const EditorContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  border: 1px solid ${colors.border.light};
  border-radius: 8px;
  overflow: hidden;
  background-color: ${colors.background.secondary};

  &:focus-within {
    border-color: ${colors.primary.main};
  }
`;

export const Toolbar = styled(Box)`
  display: flex;
  gap: 4px;
  padding: 8px 12px;
  background-color: ${colors.background.default};
  border-bottom: 1px solid ${colors.border.light};
`;

export const ToolbarButton = styled.button<{ isActive?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 4px;
  background-color: ${({ isActive }) =>
    isActive ? colors.background.lightBlue : "transparent"};
  color: ${({ isActive }) =>
    isActive ? colors.primary.main : colors.text.primary};
  cursor: pointer;
  font-weight: ${({ isActive }) => (isActive ? "bold" : "normal")};
  font-size: 14px;
  font-family: "Nunito", sans-serif;

  &:hover {
    background-color: ${colors.background.lightBlue};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const EditorContent = styled(Box)`
  min-height: 100px;
  max-height: 300px;
  overflow-y: auto;
  padding: 12px 16px;
  font-family: "Nunito", sans-serif;
  font-size: 14px;
  line-height: 1.6;
  color: ${colors.text.primary};
  outline: none;

  &:empty::before {
    content: attr(data-placeholder);
    color: ${colors.text.secondary};
    pointer-events: none;
  }

  p {
    margin: 0 0 8px 0;
  }

  p:last-child {
    margin-bottom: 0;
  }

  b,
  strong {
    font-weight: 700;
  }

  i,
  em {
    font-style: italic;
  }

  u {
    text-decoration: underline;
  }
`;

export const Label = styled.label`
  font-family: "Nunito", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: ${colors.text.secondary};
  margin-bottom: 8px;
  display: block;
`;
